import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() text: string = '';
  @Input() backgroundColor: string = '';
  @Input() color: string = '';
  @Input() borderRadius: string = '';
  @Input() isDisabled: boolean = false;
  @Input() buttonCustomClass = '';
  @Output() click = new EventEmitter<any>();

  clickBtn() {
    this.click.emit();
  }
}
